import { cn } from '@qr-front/ui/utils'
import { useTranslations } from 'next-intl'

import { TABLE_ACTION_TYPE, TAction, TActionOption } from './actionOptions'

export const ActionOptionsContainer = ({
	options,
	handleOptionAction,
}: {
	options: TActionOption[]
	handleOptionAction: (key: TActionOption['key'], action: TAction) => void
}) => {
	const t = useTranslations()

	return (
		<ul className="flex flex-col gap-1">
			{options.map(({ Icon, key, translationKey, action }) => (
				<li key={key}>
					<button
						onClick={() => handleOptionAction(key, action)}
						className={cn(
							key === TABLE_ACTION_TYPE.Delete
								? 'text-error'
								: 'text-dark-grey',
							'flex min-h-10 w-full items-center gap-2 rounded-8 px-2 py-4 text-left font-body text-[0.875rem] font-normal leading-[1rem] transition-colors word-break-fix hover:bg-generator-bg desktop:py-3 [&>svg]:size-4 [&>svg]:shrink-0',
						)}
					>
						{Icon}
						{t(translationKey)}
					</button>
				</li>
			))}
		</ul>
	)
}
